import { createSelector } from "@ngrx/store";
import { EditCourseStoreSelectors } from "../components/edit-course/store";

export const selectIsLoading = createSelector(
  EditCourseStoreSelectors.selectIsLoading,
  (...isLoadings) => isLoadings.find((isLoading) => isLoading)
);
